module.exports = __webpack_public_path__ + "static/media/Desktop_Skills_8.54d7a045.png";